import { ItemGrid } from '@/components/tracker/item-grid';

export function TrackerPage() {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-zelda-gold">Item Tracker</h1>
      </div>

      <div className="flex flex-wrap gap-8">
        {/* Items Section */}
        <section
          className="self-start bg-gray-900/50 border border-gray-800 rounded-xl p-4"
          onContextMenu={(e) => e.preventDefault()}
        >
          <ItemGrid />
        </section>
      </div>
    </div>
  );
}
